import { IColumnValidator, IValidationResult } from "@schemas/excelImportSchema";

export const validateExcelData = (
  data: (string | number)[][],
  validators: IColumnValidator[],
  skipValidateRows = 0,
): IValidationResult[][] => {
  const validatedData: IValidationResult[][] = [];

  for (let row = 0; row < data.length; row++) {
    const validatedRow: IValidationResult[] = [];
    const rowValues = data[row];

    if (rowValues.length === 0) {
      validatedRow.push({ isValid: false, value: "", col: 0, row });
      validatedData.push(validatedRow);
      continue;
    }

    for (let col = 0; col < rowValues.length; col++) {
      const value = rowValues[col];

      if (row < skipValidateRows) {
        validatedRow.push({ isValid: null, value, col, row });
      } else {
        const isValid = validators[col]?.validate(value, data, row, col) ?? null;
        validatedRow.push({ isValid, value, col, row });
      }
    }

    validatedData.push(validatedRow);
  }

  return validatedData;
};

export const formatImportedExcelData = (data: string[][]): [string, string, string?, string?][] => {
  const converted = data
    .filter((row) => {
      return row.length > 0;
    })
    .map((row) => {
      // Använd fallback-värden om kolumner saknas
      const nr = row[0] ? row[0].toString().trim() : "";
      const description = row[1] ? row[1].toString().trim() : "";
      const reference = row[2] ? row[2].toString().trim() : ""; // Valfritt
      const itemTags = row[3] ? row[3].toString().trim() : ""; // Valfritt, kommaseparerat om flera taggar
      return { nr, description, reference, itemTags };
    });
  converted.shift(); // Ta bort första raden (header)
  const checklistRows: [string, string, string?, string?][] = converted.map((row) => [
    String(row.nr),
    String(row.description),
    row.reference || undefined, // Valfritt fält
    row.itemTags || undefined, // Valfritt fält
  ]);
  return checklistRows;
};
